const handleMarketplaceMVTActivation = ({
  marketplaceMVTDesktopInstance,
  marketplaceMVTDesktopBucket,
  marketplaceMVTMobileInstance,
  marketplaceMVTMobileBucket
}) => {
  marketplaceMVTDesktopBucket !== "default" &&
    marketplaceMVTDesktopInstance?.isEnabled();
  marketplaceMVTMobileBucket !== "default" &&
    marketplaceMVTMobileInstance?.isEnabled();
};

export default handleMarketplaceMVTActivation;
